import { Button, type ButtonProps } from "./Button";
import {
  BUTTON_PRIMITIVE_DEFAULTS,
  type CanonicalButtonTone,
} from "../ui/primitives/buttonPrimitiveSpec";

export interface MenuActionButtonProps
  extends Omit<ButtonProps, "variant" | "size" | "tone"> {
  tone?: CanonicalButtonTone;
}

export function MenuActionButton({
  tone = BUTTON_PRIMITIVE_DEFAULTS.tone,
  className = "",
  type = "button",
  ...props
}: MenuActionButtonProps) {
  return (
    <Button
      {...props}
      type={type}
      variant="link"
      size="sm"
      tone={tone}
      className={["text-sm", className].filter(Boolean).join(" ")}
    />
  );
}
